export default __webpack_public_path__ + "static/media/500.67dd7a7c.png";